<template>
  <div class="payment-page">
    <div class="pricing-inner">
						<h1 class="title is-1 mb-6 text-center">Plans</h1>
						<div class="text-center">
							<div class="pricing-tables-wrap">

								<div class="pricing-table is-revealing" style="max-width: 365px;">
									<div class="pricing-table-inner">
										<div class="pricing-table-main">
											<div class="pricing-table-header mb-24 pb-24">
												<div class="pricing-table-price"><span
														class="pricing-table-price-amount">150</span>₹ / month</div>
												<p class="has-text-weight-bold">Basic</p>
											</div>
											<ul class="pricing-table-features list-reset text-xs">
												<li>
													<span>QR-menu + website + app</span>
													<li class="check-gray">
														<span>Ordering</span>
													</li>
													<li class="check-gray">
														<span>AI Assistant</span>
													</li>
												
												<!-- <li>
													<span>1 update per day</span>
												</li> -->
												
											</ul>
										</div>
										<div class="pricing-table-cta">
											<button class="button upgrade"
												@click="goToPayment(150)">Upgrade to Basic</button>
										</div>
									</div>
								</div>

								<div class="pricing-table is-revealing" style="max-width: 365px;">
									<div class="pricing-table-inner">
										<div class="pricing-table-main">
											<div class="pricing-table-header mb-24 pb-24">
												<div class="pricing-table-price"><span
														class="pricing-table-price-amount">950</span>₹ / month</div>
												<p class="has-text-weight-bold">Pro</p>
											</div>
											<ul class="pricing-table-features list-reset text-xs">
												<li>
													<span>QR-menu + website + app</span>
												</li>
												<li>
													<span>Ordering</span>
												</li>
												<li>
													<span>AI Assistant</span>
												</li>
											</ul>
										</div>
										<div class="pricing-table-cta">
											<button class="button upgrade"
												@click="goToPayment(950)">Upgrade to Pro</button>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
  </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "../api";
import _ from "underscore";

export default {
  name: "Payment",
  computed: _.extend(
    {},
    mapGetters({
      place: "getPlaceInfo",
      identityId: "getIdentityId"
    }),
    {}
  ),
  data() {
    return {
      showInfoBlock: false,
      isLoading: false
    };
  },
  methods: _.extend({}, mapActions(["populatePlaceInfo", "updatePlaceInfo"]), {
    goToPayment: function(plan) {
      window.beforeunload = function () {}
      this.isLoading = true;
      this.$ma.trackEvent({category: 'event', action: 'Payment initiated: Razor:' +plan, label : null, value : null})
    //   let body = {
    //     Customer_IDP: this.identityId,
    //     email: this.place.email
    //   };
    //   api.uniCreatePaymentLink(body).then(response => {
    //     // this.isLoading = false
    //     window.open(response.data, "_self");
    //   });
    //   // api.sendNotification({message: 'Payment attempted: ' + this.place.url});
    //   this.$ma.trackEvent({category: 'event', action: 'Payment initiated: savemenu.app', label : null, value : null})
		var payment_url = "https://rzp.io/l/sgaWcK3"
		if (plan == 950) payment_url = "https://rzp.io/l/jKkpm3Q7"
        window.open(payment_url, "_self");
    },
  nextDate: function() {
    let today = new Date()
    let newDate = new Date(today.setDate(today.getDate() + 30));
    let dd = String(newDate.getDate()).padStart(2, '0');
    let mm = String(newDate.getMonth() + 1).padStart(2, '0');
    let yyyy = newDate.getFullYear();
    return mm + '/' + dd + '/' + yyyy;
  }
  }),
  mounted() {
    window.onbeforeunload = function () {}
    this.$title = this.$t('title') + " | " + this.$t('Payment.title')
    this.$ma.trackEvent({category: 'event', action: 'Page viewed: ' + this.$route.fullPath, label : null, value : null})
  }
};



</script>



<style scoped>
.pricing {
	position: relative
}

.pricing .section-inner {
	padding-bottom: 0
}

.pricing .section-title {
	margin-bottom: 48px
}

.pricing .accordion {
	margin-top: 12px;
	margin-bottom: 0
}


.pricing-tables-wrap {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	margin-right: -12px;
	margin-left: -12px;
	margin-top: -12px
}

.pricing-tables-wrap:last-of-type {
	margin-bottom: -12px
}

.pricing-tables-wrap:not(:last-of-type) {
	margin-bottom: 12px
}

.pricing-table {
	padding: 12px;
	width: 344px;
	max-width: 344px;
	-webkit-box-flex: 1;
	-ms-flex-positive: 1;
	flex-grow: 1
}

.pricing-table-inner {
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	background: #fff;
	padding: 24px;
	height: 100%
}

.pricing-table-inner>* {
	position: relative;
	width: 100%
}

.pricing-table-inner::before {
	content: '';
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	-webkit-box-shadow: 0 16px 48px rgba(32, 41, 50, 0.12);
	box-shadow: 0 16px 48px rgba(32, 41, 50, 0.12);
	mix-blend-mode: multiply
}

.pricing-table-header {
	/* font-family: "Arimo", sans-serif; */
	position: relative;
  margin-bottom: 3rem;
}

.pricing-table-header::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	display: block;
	height: 1px;
	background: #DEE3E9;
	background: -webkit-gradient(linear, left top, right top, color-stop(0, rgba(222, 227, 233, 0.1)), color-stop(50%, rgba(222, 227, 233, 0.6)), to(rgba(222, 227, 233, 0.1)));
	background: linear-gradient(to right, rgba(222, 227, 233, 0.1) 0, rgba(222, 227, 233, 0.6) 50%, rgba(222, 227, 233, 0.1) 100%)
}

.pricing-table-price-currency {
	font-size: 32px;
	line-height: 42px;
	letter-spacing: -0.1px
}

.pricing-table-features {
	margin-bottom: 90px
}

.pricing-table-features li {
	/* color: #889BB0; */
	font-weight: 600;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	margin-bottom: 12px
}

.pricing-table-features li::before {
	content: '';
	width: 18px;
	height: 18px;
	margin-right: 12px;
	background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' role='img' height='18' fill='rgb(25, 168, 101)'><path d='M19.972 4.075c-2.025-2.025-4.823-3.278-7.914-3.278-6.181 0-11.191 5.011-11.191 11.191 0 3.090 1.253 5.888 3.278 7.914v0c2.025 2.025 4.823 3.278 7.914 3.278 6.181 0 11.191-5.011 11.191-11.191 0-3.090-1.253-5.888-3.278-7.914v0zM12.059 21.68c-5.344 0-9.691-4.348-9.691-9.691s4.348-9.691 9.691-9.691 9.691 4.348 9.691 9.691-4.348 9.691-9.691 9.691z'></path><path d='M10.372 14.335l-3.441-3.441-1.061 1.061 4.502 4.502 7.852-7.852-1.061-1.061-6.791 6.791z'></path></svg>");
	background-repeat: no-repeat
}
li.check-gray::before {
	content: '';
	width: 18px;
	height: 18px;
	margin-right: 12px;
	background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' role='img' height='18' fill='rgb(172, 171, 171)'><path d='M19.972 4.075c-2.025-2.025-4.823-3.278-7.914-3.278-6.181 0-11.191 5.011-11.191 11.191 0 3.090 1.253 5.888 3.278 7.914v0c2.025 2.025 4.823 3.278 7.914 3.278 6.181 0 11.191-5.011 11.191-11.191 0-3.090-1.253-5.888-3.278-7.914v0zM12.059 21.68c-5.344 0-9.691-4.348-9.691-9.691s4.348-9.691 9.691-9.691 9.691 4.348 9.691 9.691-4.348 9.691-9.691 9.691z'></path><path d='M10.372 14.335l-3.441-3.441-1.061 1.061 4.502 4.502 7.852-7.852-1.061-1.061-6.791 6.791z'></path></svg>");
	background-repeat: no-repeat
}

.check-gray span {
	color: #acabab;
	text-decoration: line-through;
}

.pricing-table-cta {
	-ms-flex-item-align: end;
	align-self: flex-end
}

.pricing-table-price-amount {
    font-size: 58px;
    font-weight: bold;
}

.container .container-sm.pricing-faqs {
	max-width: 664px
}

.pricing .title {
    color: #3c4b64;
}


@media (min-width: 641px) {
	.pricing .section-title {
		margin-bottom: 72px
	}

	.pricing::before {
		left: calc(50% - 720px)
	}
}
</style>
